module.exports = __webpack_public_path__ + "img/portal_no_bg.abbbee20.png";